import { render, staticRenderFns } from "./ObjectsCustomKanban.vue?vue&type=template&id=47a962c2&scoped=true&"
import script from "./ObjectsCustomKanban.vue?vue&type=script&lang=js&"
export * from "./ObjectsCustomKanban.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsCustomKanban.vue?vue&type=style&index=0&id=47a962c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a962c2",
  null
  
)

export default component.exports